import { useState } from 'react';

export type StepType = 'current-password' | 'new-password';

export const useChangePasswordStep = () => {
  const [step, setStep] = useState<StepType>('current-password');

  const renderNextPage = () => setStep('new-password');
  const renderPrevPage = () => setStep('current-password');

  return {
    step,
    renderNextPage,
    renderPrevPage
  };
};
